import React, { Component } from 'react';
import { getOwnerContract }  from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';

class Contract extends Component {

    state = {
    };

    async componentDidMount() {
      // window.googleTranslateElementInit = () => {
      //   new window.google.translate.TranslateElement(
      //     { pageLanguage: 'en' },
      //     'google_translate_element'
      //   );
      // };
  
      // // Add the script tag to the HTML document
      // const script = document.createElement('script');
      // script.src = 'http://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      // script.defer = true;
      // document.body.appendChild(script);

    }

    addToMetamask = async () => {
        try {
            // wasAdded is a boolean. Like any RPC method, an error may be thrown.
            const wasAdded = await window.ethereum.request({
              method: 'wallet_watchAsset',
              params: {
                type: 'ERC20', // Initially only supports ERC20, but eventually more!
                options: {
                  address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', // The address that the token is at.
                  // address: '0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8', // The address that the token is at.
                  symbol: 'USDT', // A ticker symbol or shorthand, up to 5 chars.
                  decimals: 6, // The number of decimals in the token
                    //   image: tokenImage, // A string url of the token logo
                },
              },
            });
          
            if (wasAdded) {
              console.log('Thanks for your interest!');
            } else {
              console.log('Your loss!');
            }
          } catch (error) {
            console.log(error);
          }
    }

    addBUSOToMetamask = async () => {
      try {
          // wasAdded is a boolean. Like any RPC method, an error may be thrown.
          const wasAdded = await window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
              type: 'ERC20', // Initially only supports ERC20, but eventually more!
              options: {
                address: '0x7E26081D41fD9a18a32b66268C8cC5c621eb1cF2', // The address that the token is at.
                // address: '0x7b89E846a430F0E4C220E0a7caf2D4dA0D6a777f', // The address that the token is at.
                symbol: 'BUSO', // A ticker symbol or shorthand, up to 5 chars.
                decimals: 6, // The number of decimals in the token
                  //   image: tokenImage, // A string url of the token logo
              },
            },
          });
        
          if (wasAdded) {
            console.log('Thanks for your interest!');
          } else {
            console.log('Your loss!');
          }
        } catch (error) {
          console.log(error);
        }
    }

    render() { 
        return (
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
                    <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
                        {/* Top Panel, Matrix levels and all activies inside below div */}
                        <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                            <div className="text-lg sm:text-md">
                                USDT Contract Address: <a href='https://polygonscan.com/address/0xc2132D05D31c914a87C6611C10748AEb04B58e8F' target="_blank">0xc2132D05D31c914a87C6611C10748AEb04B58e8F</a> 
                                {/* USDT Contract Address: <a href='https://mumbai.polygonscan.com/address/0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8' target="_blank">0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8</a>  */}
                            </div>
                            <div className="text-lg sm:text-md">
                                BUSO Contract Address: <a href='https://polygonscan.com/address/0x7E26081D41fD9a18a32b66268C8cC5c621eb1cF2' target="_blank">0x7E26081D41fD9a18a32b66268C8cC5c621eb1cF2</a> 
                                {/* BUSO Contract Address: <a href='https://mumbai.polygonscan.com/address/0x7b89E846a430F0E4C220E0a7caf2D4dA0D6a777f' target="_blank">0x7b89E846a430F0E4C220E0a7caf2D4dA0D6a777f</a>  */}
                            </div>
                            <div>
                                <button style={{background: 'white'}}
                                        className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-4 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 py-5 !px-10 sm:py-5 sm:mt-7.5"
                                        onClick={this.addToMetamask} id="nextButton" >Add USDT To Metamask</button>
                            </div>
                            <div>
                                <button style={{background: 'white'}}
                                        className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-4 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 py-5 !px-10 sm:py-5 sm:mt-7.5"
                                        onClick={this.addBUSOToMetamask} id="nextButton" >Add BUSO To Metamask</button>
                            </div>
                            <div className="text-lg sm:text-md">
                                Matrix Contract: <a href='https://polygonscan.com/address/0x7154ca1986e59D45F34AA4e509008D7dB5680940' target="_blank">0x7154ca1986e59D45F34AA4e509008D7dB5680940</a>
                            </div>
                            <div className="text-lg sm:text-md">
                                Global Reward Contract: <a href='https://polygonscan.com/token/0xc2132d05d31c914a87c6611c10748aeb04b58e8f?a=0x381645d74a75b3E1d4aBa35c0764199199c2D8F9' target="_blank">0x381645d74a75b3E1d4aBa35c0764199199c2D8F9</a>
                                
                            </div>
                            <div className="text-lg sm:text-md">
                                Treasury Contract: <a href='https://polygonscan.com/address/0xACBb87A0F25C300F825d0C81c5e3Bff15547eAFd' target="_blank">0xACBb87A0F25C300F825d0C81c5e3Bff15547eAFd</a>
                                
                            </div>
                        </div>
                        {/* Top Panel, Matrix levels and all activies inside above div */}
                    </div>
                    < footer style={{ background: "#18191A", padding: "20px" }}
                            className="flex lg:flex-col items-center mt-auto justify-between lg:justify-start lg:items-start py-10 w-full lg:p-5 lg:pb-9 pb-0 lg:pb-0 z-10">
                            <div className="hidden lg:block mb-7.5">
                                <div className="flex space-x-5 w-full"><a
                                        className="w-6 h-6 sm:w-7 sm:h-7 flex justify-center items-center rounded-full bg-white-100 hover:bg-white-300"
                                        target="_blank" href="https://t.me/sxm2023"><svg
                                            className="w-3 h-3 sm:w-4 sm:h-4" viewBox="0 0 14 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path clipRule="evenodd"
                                                d="M11.915.776.841 5.168a.4.4 0 0 0 .03.755l2.79.864 1.133 3.503a.4.4 0 0 0 .653.17l1.64-1.523 3.11 2.29a.4.4 0 0 0 .627-.231l2.166-9.294a.8.8 0 0 0-1.075-.926Zm-6.483 6.74-.346 2.072-.8-2.901 7.816-5.1-6.67 5.929Z"
                                                fill="#fff"></path>
                                        </svg></a>

                                </div>
                            </div>
                            {/* <div id="google_translate_element"></div> */}

                            <span className="text-white-500 text-xs font-normal lg:mb-2.5">© 2023 All Rights
                                Reserved</span>
                        
                        </footer>
            </div>
        );
    }
}
 
export default withWrapper(Contract);